import { useState, Suspense, useEffect } from "react";
import { Link } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import TemporaryDrawer from "./drawer";
import { GetBlanceSlice } from "../../redux/slices/getbalance";
import { SliderBanner } from "../slider";
import * as animationData from "../../Animations/fire.json";
import Lottie from "react-lottie";
import LockResetIcon from "@mui/icons-material/LockReset";
import AddCardIcon from "@mui/icons-material/AddCard";
import RedeemIcon from "@mui/icons-material/Redeem";
import { ablyClient } from "../../lib/socket";
import { toast } from "react-toastify";
import {
  AddGameModel,
  CraditBal,
  RadeemAccount,
  ResetPass,
} from "../modal/allModels";

const Maincontent = ({ data }) => {
  const dispatch = useDispatch();
  const [ref, setRef] = useState("asdf");
  const user = useSelector((val) => val?.login?.user);

  const loading = useSelector((val) => val?.load);
  const games = useSelector((val) => val?.games?.data);
  const refresh = useSelector((val) => val?.up);
  const [copiedMessage, setCopiedMessage] = useState({});
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [addGameModal, setAddGameModal] = useState(false);
  const [creditBalanceModal, setCreditBalanceModal] = useState(false);
  const [redeemModal, setRedeemModal] = useState(false);
  const [resetModal, setResetModal] = useState(false);

  const handleCopy = (text, type, index) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedMessage((prev) => ({
        ...prev,
        [index]: `${type} Copied!`,
      }));
      setTimeout(() => {
        setCopiedMessage((prev) => ({
          ...prev,
          [index]: "",
        }));
      }, 2000);
    });
  };
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };
  useEffect(() => {
    const channel = ablyClient.channels.get("admin-credit");
    const messageHandler = async (message) => {
      const { senderId, receiverId, text } = message.data;
      const userid = user?.id;

      const obj = data?.[0];
      const object = {
        name: obj?.name,
        username: obj?.username,
        uid: user?.id,
        gamebalance: obj?.amount,
        wins: obj?.winsamount,
        gameid: obj?.gameid,
        slug: obj?.slug,
      };
      if (senderId) {
        // setMessages((prev) => [...prev, { senderId, receiverId, text }]);
        // dispatch(GetBlanceSlice(object));
      }
    };

    channel.subscribe("private-credit", messageHandler);

    return () => {
      channel.unsubscribe("private-credit", messageHandler);
    };
  }, [dispatch]);
  useEffect(() => {
    const channel = ablyClient.channels.get("admin-redeem");
    const userid = user?.id;

    const messageHandler = (message) => {
      const { senderId, receiverId, text } = message.data;
      const obj = data?.[0];
      const object = {
        name: obj?.name,
        username: obj?.username,
        uid: user?.id,
        gamebalance: obj?.amount,
        wins: obj?.winsamount,
        gameid: obj?.gameid,
        slug: obj?.slug,
      };
      if (senderId) {
        // dispatch(GetBlanceSlice(object));
      }
    };

    channel.subscribe("private-redeem", messageHandler);

    return () => {
      channel.unsubscribe("private-redeem", messageHandler);
    };
  }, [dispatch]);

  const [cooldown, setCooldown] = useState(false);

  const handleClick = (object) => {
    if (!object?.gameid || !object?.uid) return toast.error("try again..");
    if (cooldown) return;
    setRef(object?.name);
    setCooldown(true);
    dispatch(GetBlanceSlice(object));
    setTimeout(() => {
      setCooldown(false);
    }, 60000);
  };

  return (
    <>
      {/* <AddGameModal /> */}
      <AddGameModel
        isOpen={addGameModal}
        onCancel={() => setAddGameModal(false)}
      />
      {/* <Credit balance modal /> */}
      <CraditBal
        isOpen={creditBalanceModal}
        onCancel={() => {
          setCreditBalanceModal(false);
          setSelectedSlot(null);
        }}
        game={selectedSlot}
      />
      {/* <Redeem balance modal /> */}
      <RadeemAccount
        isOpen={redeemModal}
        onCancel={() => {
          setRedeemModal(false);
          setSelectedSlot(null);
        }}
        game={selectedSlot}
      />
      <ResetPass
        game={selectedSlot}
        isOpen={resetModal}
        onCancel={() => {
          setResetModal(false);
          setSelectedSlot(null);
        }}
      />
      <section
        className={`flex-1 ${
          games?.remainggames?.length > 0 ? "w-[50%]" : "w-[70vw]"
        } bg-[#280203] rounded-lg shadow-lg pb-20`}
      >
        {games?.remainggames?.length > 0 && (
          <TemporaryDrawer data={games?.remainggames} />
        )}
        <div className="float-left w-full">
          <div>
            <SliderBanner />
          </div>

          <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-6 pl-2 mt-4">
            <Suspense fallback={GameSlotGlimmer}>
              {data?.length > 0 &&
                data.map((slot, index) => {
                  const object = {
                    name: slot.name,
                    username: slot.username,
                    uid: user?.id,
                    gamebalance: slot?.amount,
                    wins: slot?.winsamount,
                    gameid: slot?.gameid,
                    slug: slot?.slug,
                  };
                  if (slot?.active > 0) {
                    return (
                      <div
                        key={index}
                        className=" relative bg-gradient-to-b p-4 rounded-lg shadow hover:shadow-lg transition flex flex-col gap-4"
                        style={{
                          background:
                            "linear-gradient(to bottom, #f9f0ea, #b1e1fa)",
                        }}
                      >
                        <div className="flex items-center gap-4">
                          <img
                            src={`${process.env.REACT_APP_APIURL}/${slot.logo}`}
                            alt={slot.name}
                            className="w-16 h-16  rounded-lg object-cover"
                          />
                          <div>
                            <h4 className="font-bold text-black">
                              {slot.name}
                            </h4>
                            <p className="text-lg text-gray-700 font-bold">
                              <i className="las la-dollar-sign text-lg"></i>
                              {`${slot?.amount}`}{" "}
                              <button
                                onClick={() => {
                                  const object = {
                                    name: slot?.name,
                                    username: slot?.username,
                                    uid: user?.id,
                                    gamebalance: slot?.amount,
                                    wins: slot?.winsamount,
                                    gameid: slot?.gameid,
                                    slug: slot?.slug,
                                  };
                                  handleClick(object);
                                  setSelectedSlot(object);
                                  setRef(slot?.name);
                                }}
                                className="mr-2"
                                disabled={cooldown}
                              >
                                {refresh?.loading && ref === slot?.name ? (
                                  <i className="las la-sync-alt text-lg animate-spin"></i>
                                ) : (
                                  <i className="las la-sync-alt text-lg "></i>
                                )}
                              </button>
                              {/* <button
                                className="relative"
                                onClick={HandleRTransfer}
                              >
                                <i
                                  title="Winnings credited to your balance?"
                                  className="las la-exchange-alt"
                                ></i>
                              </button> */}
                            </p>
                            {/* {(slot?.gameid === "67866b36e8a5ed5e5bdf59f8") |
                            (slot?.gameid === "67866b36e8a5ed5e5bdf59f1") &&
                           : (
                            ""
                          )} */}
                            {slot?.winsamount > 0 && (
                              <p className="text-lg text-gray-700 font-bold">
                                <i className="las la-dollar-sign text-lg"></i>
                                {`wins: ${
                                  parseInt(slot?.winsamount)
                                    ? parseInt(slot?.winsamount)
                                    : ""
                                }`}
                              </p>
                            )}
                            {/* <p className="flex items-center gap-2 text-sm text-green-600">
                          <img
                            src="/images/header/active.png"
                            alt="Active"
                            className="w-4 h-4"
                          />
                          
                        </p> */}
                          </div>
                        </div>

                        <div className="text-left text-sm text-gray-700 space-y-2">
                          <div className="relative">
                            {copiedMessage[index] === "Game ID Copied!" && (
                              <span className="absolute -top-6 left-0 bg-green-500 text-white text-xs rounded py-1 px-2 shadow">
                                {copiedMessage[index]}
                              </span>
                            )}
                            <p className="flex items-center gap-2 text-sm font-bold">
                              <i className="las la-address-card"></i>
                              <strong>Game ID:</strong>
                              <span
                                className="truncate"
                                style={{ maxWidth: "50%" }}
                                title={slot.username}
                              >
                                {slot.username}
                              </span>
                              <i
                                className="las la-copy cursor-pointer text-purple-500 hover:text-purple-700 text-2xl"
                                title="Copy Game ID"
                                onClick={() =>
                                  handleCopy(slot.username, "Game ID", index)
                                }
                              ></i>
                            </p>
                          </div>

                          {
                            <div className="relative">
                              {copiedMessage[index] === "Password Copied!" && (
                                <span className="absolute -top-6 left-0 bg-green-500 text-white text-xs rounded py-1 px-2 shadow">
                                  {copiedMessage[index]}
                                </span>
                              )}
                              <p className="flex items-center gap-2 text-sm font-bold">
                                <i className="las la-lock"></i>
                                <strong>Password:</strong>
                                <span
                                  className="truncate"
                                  style={{ maxWidth: "50%" }}
                                  title={slot.password}
                                >
                                  {slot.password}
                                </span>
                                <i
                                  className="las la-copy cursor-pointer text-purple-500 hover:text-purple-700 text-2xl"
                                  title="Copy Password"
                                  onClick={() =>
                                    handleCopy(slot.password, "Password", index)
                                  }
                                ></i>
                              </p>
                            </div>
                          }
                        </div>

                        <div className="grid grid-cols-2 gap-2">
                          <button
                            onClick={() => {
                              setSelectedSlot(object);
                              setCreditBalanceModal(true);
                            }}
                            className="flex items-center gap-2 bg-blue-600 text-white text-[13px]
                           py-2 px-2  rounded-lg hover:bg-blue-700 transition"
                          >
                            <AddCardIcon />
                            <span
                              className="truncate"
                              style={{ maxWidth: "90%" }}
                            >
                              Add Credits
                            </span>
                          </button>
                          <button
                            onClick={() => {
                              if (parseInt(slot.amount) >= 50) {
                                setSelectedSlot(object);
                                setRedeemModal(true);
                              } else {
                                toast.error(
                                  "Min. $50 required to proceed with redeem."
                                );
                              }
                            }}
                            className="flex items-center gap-2 bg-orange-600 text-white py-2 text-[13px]
                           px-2  rounded-lg hover:bg-orange-700 transition"
                          >
                            <RedeemIcon />
                            <span className="" style={{ maxWidth: "90%" }}>
                              Redeem
                            </span>
                          </button>

                          <button
                            onClick={() => {
                              setResetModal(true);
                              setSelectedSlot(object);
                            }}
                            className="flex items-center gap-2 bg-gray-400 text-white py-2 text-[13px]
                           px-2  rounded-lg hover:bg-gray-500 transition"
                          >
                            <LockResetIcon />
                            <span className="" style={{ maxWidth: "90%" }}>
                              {slot?.gameid === "67866b36e8a5ed5e5bdf59f8"
                                ? "Remove Password"
                                : "Reset Password"}
                            </span>
                          </button>

                          {slot?.apk && (
                            <Link
                              to={slot?.apk}
                              className="flex items-center gap-2 bg-gray-600 text-white py-2 text-[13px]
                             px-2  rounded-lg hover:bg-gray-700 transition"
                            >
                              <i className="las la-download text-lg"></i>
                              <span className="" style={{ maxWidth: "90%" }}>
                                Download APK
                              </span>
                            </Link>
                          )}
                        </div>
                        <button
                          className="flex items-center justify-center gap-2 bg-yellow-400 py-2 w-full rounded-lg
             hover:bg-yellow-600 font-extrabold transition text-lg text-black"
                          onClick={() => window.open(slot.url, "_blank")}
                        >
                          <Lottie
                            options={defaultOptions}
                            height={30}
                            width={30}
                            loop
                            autoplay
                          />
                          <i className="las la-gamepad text-4xl leading-none mr-2 game-icon"></i>
                          <span className="zoom-in-out respo-fs">PLAY NOW</span>
                          <Lottie
                            options={defaultOptions}
                            height={30}
                            width={30}
                            loop
                            autoplay
                          />
                        </button>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        key={index}
                        className=" relative bg-gradient-to-b p-4 rounded-lg shadow hover:shadow-lg transition flex flex-col gap-4"
                        style={{
                          background:
                            "linear-gradient(to bottom, #f9f0ea, #b1e1fa)",
                        }}
                      >
                        <div className="overflow-hidden flex-col rounded-md absolute top-0 right-0 bottom-0 left-0 bg-white/30 flex justify-center items-center z-20">
                          <svg
                            aria-hidden="true"
                            className="w-20 h-20 text-gray-300 animate-spin dark:text-gray-600 fill-[#e4008b]"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            />
                          </svg>
                          <h5 className="text-white mt-2 bg-[#b80c68] p-1 rounded text-center">
                            Getting things ready almost there
                            <span className="loading-dots">
                              <span className="dot"> .</span>
                              <span className="dot">.</span>
                              <span className="dot">.</span>
                            </span>
                          </h5>
                        </div>

                        <div className="flex items-center gap-4">
                          <img
                            src={`${process.env.REACT_APP_APIURL}/${slot.logo}`}
                            alt={slot.name}
                            className="w-16 h-16  rounded-lg object-cover"
                          />
                          <div>
                            <h4 className="font-bold text-black">
                              {slot.name}
                            </h4>
                            <p className="text-lg text-gray-700 font-bold">
                              <i className="las la-dollar-sign text-lg"></i>
                              {`${slot?.amount}`}{" "}
                              <button>
                                {ref === slot.name && refresh?.loading ? (
                                  <i className="las la-sync-alt text-lg animate-spin"></i>
                                ) : (
                                  <i className="las la-sync-alt text-lg"></i>
                                )}
                              </button>
                            </p>
                            {/* {(slot?.gameid === "67866b36e8a5ed5e5bdf59f8") |
                            (slot?.gameid === "67866b36e8a5ed5e5bdf59f1") &&
                           : (
                            ""
                          )} */}
                            {slot?.winsamount > 0 && (
                              <p className="text-lg text-gray-700 font-bold">
                                <i className="las la-dollar-sign text-lg"></i>
                                {`wins: ${
                                  parseInt(slot?.winsamount)
                                    ? parseInt(slot?.winsamount)
                                    : ""
                                }`}
                              </p>
                            )}
                            {/* <p className="flex items-center gap-2 text-sm text-green-600">
                          <img
                            src="/images/header/active.png"
                            alt="Active"
                            className="w-4 h-4"
                          />
                          
                        </p> */}
                          </div>
                        </div>

                        <div className="text-left text-sm text-gray-700 space-y-2">
                          <div className="relative">
                            {copiedMessage[index] === "Game ID Copied!" && (
                              <span className="absolute -top-6 left-0 bg-green-500 text-white text-xs rounded py-1 px-2 shadow">
                                {copiedMessage[index]}
                              </span>
                            )}
                            <p className="flex items-center gap-2 text-sm font-bold">
                              <i className="las la-address-card"></i>
                              <strong>Game ID:</strong>
                              <span
                                className="truncate"
                                style={{ maxWidth: "50%" }}
                                title={slot.username}
                              >
                                {slot.username}
                              </span>
                              <i
                                className="las la-copy cursor-pointer text-purple-500 hover:text-purple-700 text-2xl"
                                title="Copy Game ID"
                                onClick={() =>
                                  handleCopy(slot.username, "Game ID", index)
                                }
                              ></i>
                            </p>
                          </div>

                          {
                            <div className="relative">
                              {copiedMessage[index] === "Password Copied!" && (
                                <span className="absolute -top-6 left-0 bg-green-500 text-white text-xs rounded py-1 px-2 shadow">
                                  {copiedMessage[index]}
                                </span>
                              )}
                              <p className="flex items-center gap-2 text-sm font-bold">
                                <i className="las la-lock"></i>
                                <strong>Password:</strong>
                                <span
                                  className="truncate"
                                  style={{ maxWidth: "50%" }}
                                  title={slot.password}
                                >
                                  {slot.password}
                                </span>
                                <i
                                  className="las la-copy cursor-pointer text-purple-500 hover:text-purple-700 text-2xl"
                                  title="Copy Password"
                                  onClick={() =>
                                    handleCopy(slot.password, "Password", index)
                                  }
                                ></i>
                              </p>
                            </div>
                          }
                        </div>

                        <div className="grid grid-cols-2 gap-2">
                          <button
                            className="flex items-center gap-2 bg-blue-600 text-white text-[13px]
                           py-2 px-2  rounded-lg hover:bg-blue-700 transition"
                          >
                            <AddCardIcon />
                            <span
                              className="truncate"
                              style={{ maxWidth: "90%" }}
                            >
                              Add Credits
                            </span>
                          </button>
                          <button
                            className="flex items-center gap-2 bg-orange-600 text-white py-2 text-[13px]
                           px-2  rounded-lg hover:bg-orange-700 transition"
                          >
                            <RedeemIcon />
                            <span className="" style={{ maxWidth: "90%" }}>
                              Redeem
                            </span>
                          </button>
                          {slot?.gameid != "67866b36e8a5ed5e5bdf59f8" && (
                            <button
                              className="flex items-center gap-2 bg-gray-400 text-white py-2 text-[13px]
                           px-2  rounded-lg hover:bg-gray-500 transition"
                            >
                              <LockResetIcon />
                              <span className="" style={{ maxWidth: "90%" }}>
                                {slot?.gameid === "67866b36e8a5ed5e5bdf59f8"
                                  ? "Remove Password"
                                  : "Reset Password"}
                              </span>
                            </button>
                          )}

                          {slot?.apk && (
                            <Link
                              to={slot?.apk}
                              className="flex items-center gap-2 bg-gray-600 text-white py-2 text-[13px]
                             px-2  rounded-lg hover:bg-gray-700 transition"
                            >
                              <i className="las la-download text-lg"></i>
                              <span className="" style={{ maxWidth: "90%" }}>
                                Download APK
                              </span>
                            </Link>
                          )}
                        </div>
                        <button
                          className="flex items-center justify-center gap-2 bg-yellow-400 py-2 w-full rounded-lg
             hover:bg-yellow-600 font-extrabold transition text-lg text-black"
                          onClick={() => window.open(slot.url, "_blank")}
                        >
                          <Lottie
                            options={defaultOptions}
                            height={30}
                            width={30}
                            loop
                            autoplay
                          />
                          <i className="las la-gamepad text-4xl leading-none mr-2 game-icon"></i>
                          <span className="zoom-in-out respo-fs">PLAY NOW</span>
                          <Lottie
                            options={defaultOptions}
                            height={30}
                            width={30}
                            loop
                            autoplay
                          />
                        </button>
                      </div>
                    );
                  }
                })}
            </Suspense>

            <Suspense
              fallback={
                <div className="bg-gray-200 p-4 rounded-lg shadow animate-pulse flex flex-col justify-center items-center h-[417px]">
                  <div className="text-center">
                    <div className="w-32 h-6 bg-gray-300 rounded mb-2"></div>
                    <div className="w-12 h-12 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              }
            >
              {games?.remainggames?.length > 0 && (
                <div
                  className="bg-gradient-to-b p-4 rounded-lg shadow hover:shadow-lg transition flex flex-col justify-center items-center h-[417px]"
                  style={{
                    background: "linear-gradient(to bottom, #f9f0ea, #b1e1fa)",
                  }}
                >
                  <div className="text-center">
                    <p className="font-bold text-gray-800 mb-2 text-lg">
                      + Add New Game
                    </p>
                    <button
                      className="bg-gray-400 text-white text-[24px] py-1 px-6 font-extrabold
                       rounded-lg hover:bg-gray-500 transition"
                      onClick={() => setAddGameModal(true)}
                    >
                      <i className="las la-plus text-lg"></i>
                    </button>
                  </div>
                </div>
              )}
            </Suspense>
          </div>
        </div>
      </section>
    </>
  );
};

function GameSlotGlimmer() {
  return (
    <div className="relative bg-gray-200 p-4 rounded-lg shadow animate-pulse flex flex-col gap-4">
      <div className="flex items-center gap-4">
        <div className="w-16 h-16 bg-gray-300 rounded-lg" />
        <div className="flex flex-col gap-2">
          <div className="w-32 h-5 bg-gray-300 rounded" />
          <div className="w-20 h-4 bg-gray-300 rounded" />
        </div>
      </div>
      <div className="space-y-2">
        <div className="w-full h-4 bg-gray-300 rounded" />
        <div className="w-3/4 h-4 bg-gray-300 rounded" />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <div className="w-full h-10 bg-gray-300 rounded" />
        <div className="w-full h-10 bg-gray-300 rounded" />
        <div className="w-full h-10 bg-gray-300 rounded" />
        <div className="w-full h-10 bg-gray-300 rounded" />
      </div>
      <div className="w-full h-12 bg-gray-400 rounded" />
    </div>
  );
}

export default Maincontent;
